
// tells an object to "do what it does", for example
// send out a message
export const BANG = "bang";

// used for sharing scales between nodes
export const SCALE = "scale";

// used for sharing chords between nodes
export const CHORD = "chord";

export const TRIGGER_ROUTING = "trigger-routing";

export const ALL = "all";

export const RESET = "reset";

export const CYCLE_RESTART = "cycle-restart";

export const SNAPSHOT_CHANGED = "snapshot-changed";
export const USE_SNAPSHOT = "use-snapshot";
export const TICK = "tick";
export const RESTART_SEQUENCER = "restart-sequencer";
export const STOP = "stop";
export const START = "start";
export const TRIGGER = "trigger";
export const RULES = "rules";
export const FIGURES = "figures";
export const PARAMS = "params";
export const TIDALS = "tidals";
export const CHOKE = "choke";
export const GRID_OPERATION = "grid-operation";


export const SWAP_MIN_MAX = "swap-min-max";
export const NFT = "nft";
